import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { S1Modal, S1ButtonType, S1UIService, S1ModalSizes } from '@app/s1';
import { ICassa, TipoCassa } from '@app/shared/models/cassa';
import { CassaService } from '@app/shared/services/cassa.service';

@Component({
  selector: 'ser-cassa',
  templateUrl: './cassa.component.html',
  styleUrl: './cassa.component.scss'
})
export class CassaComponent {

  @Output() updated = new EventEmitter<boolean>();
  @Output() created = new EventEmitter<string>();

  @ViewChild('modal') modal: S1Modal;

  s1ButtonType = S1ButtonType;
  tipoCassa = TipoCassa;

  cassaForm: UntypedFormGroup;
  cassa: ICassa;
  isNew: boolean = true;
  idStazione: string;

  constructor(private formBuilder: UntypedFormBuilder, private cassaService: CassaService, private ui: S1UIService) {

    this.cassaForm = this.formBuilder.group({
      'codice': [Validators.required, null],
      'descrizione': [Validators.required, null],
      'tipoCassa': [null, null]
    })

  }

  ngOnInit(): void {

  }

  open(idStazione: string, cassa?: ICassa) {

    this.idStazione = idStazione;
    this.cassa = cassa;
    this.isNew = !this.cassa;

    this.cassaService.idPath = this.idStazione;
    this.cassaForm.reset();

    this.cassaForm.patchValue({
      'codice': this.cassa?.codice,
      'descrizione': this.cassa?.descrizione,
      'tipoCassa': ""+ TipoCassa[this.cassa?.tipoCassa]
    })

    this.modal.open(S1ModalSizes.MD);

  }

  close() {
    this.modal.close();
  }

  create() {

    const newCassa: ICassa = {
      "codice": this.cassaForm.controls.codice.value,
      "descrizione": this.cassaForm.controls.descrizione.value,
      "tipoCassa": this.cassaForm.controls.tipoCassa.value
    }

    this.cassaService.crea(newCassa).subscribe(cassa => {
      this.ui.showSuccessToast("casse.crea.popup.created");
      this.close();
      this.created.emit(cassa);
      this.cassaForm.reset();
    })

  }

  update() {

    const cassaToUpdate: ICassa = {
      "id": this.cassa.id,
      "codice": this.cassaForm.controls.codice.value,
      "descrizione": this.cassaForm.controls.descrizione.value,
      "tipoCassa": this.cassaForm.controls.tipoCassa.value
    }

    this.cassaService.modifica(cassaToUpdate).subscribe(success => {

      if (success) {
        this.ui.showSuccessToast("casse.crea.popup.updated");
        this.updated.emit(success);
        this.cassaForm.reset();
        this.close();
      }
      
    })

  }

}